import { createBrowserRouter } from "react-router-dom";
import Main from "../layout/Main";
import PrivateRoute from "./PrivateRoute";
import Home from "../pages/Home";
import Chapters from "../pages/Chapters";
import Login from "../pages/Login";
import Quizzes from "../pages/Quizzes";
import NotFound from "../pages/not-found";
import ChapterDetails from "../pages/ChapterDetails";
import SectionDetails from "../pages/SectionDetails";
import ChaptersSelection from "../pages/ChaptersSelection";
import Statistiche from "../pages/Statistiche";
import Signup from "../pages/Signup";
import MyProfile from "../pages/MyProfile";
import QuizExam from "../pages/QuizExam";
import Functionality from "../pages/Functionality";
import AboutUs from "../pages/AboutUs";
import WharWeDo from "../pages/WharWeDo";
import Forget from "../pages/Forget";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import ContactUs from "../pages/ContactUs";
import PatenteBoi from "../pages/PatenteBoi";
import Dictionary from "../pages/Dictionary";
import VideoType from "../pages/VideoType";
import Video from "../pages/Video";
import LiveClassList from "../pages/LiveClassList";
import LiveClassDetails from "../pages/LiveClassDetails";
import TopPerformer from "../pages/TopPerformer";
import TopPerformerDetails from "../pages/TopPerformerDetails";
import QuestionsList from "../pages/QuestionsList";
import QuestionsDetails from "../pages/QuestionsDetails";

export const route = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/chapters/:id",
        element: <Chapters />,
      },
      {
        path: "/chapter-details/:id",
        element: <ChapterDetails />,
      },
      {
        path: "/section/:id",
        element: <SectionDetails />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/signup",
        element: <Signup />,
      },
      {
        path: "/forget",
        element: <Forget />,
      },
      {
        path: "/my-profile",
        element: (
          <PrivateRoute>
            <MyProfile />
          </PrivateRoute>
        ),
      },
      {
        path: "/quiz-exam/:type",
        element: (
          <PrivateRoute>
            <QuizExam />
          </PrivateRoute>
        ),
      },
      {
        path: "/quizzes/:id",
        element: <Quizzes />,
      },
      {
        path: "/chapters-selection/:id",
        element: (
          <PrivateRoute>
            <ChaptersSelection />
          </PrivateRoute>
        ),
      },
      {
        path: "/statistiche",
        element: (
          <PrivateRoute>
            <Statistiche />
          </PrivateRoute>
        ),
      },
      {
        path: "/patente-boi/:chapterId",
        element: (
          <PrivateRoute>
            <PatenteBoi />
          </PrivateRoute>
        ),
      },
      {
        path: "/dictionary",
        element: (
          <PrivateRoute>
            <Dictionary />
          </PrivateRoute>
        ),
      },
      {
        path: "/videos/:chapterId",
        element: (
          <PrivateRoute>
            <VideoType />
          </PrivateRoute>
        ),
      },
      {
        path: "/video/:videoId",
        element: (
          <PrivateRoute>
            <Video />
          </PrivateRoute>
        ),
      },
      {
        path: "/live-class-list",
        element: (
          <PrivateRoute>
            <LiveClassList />
          </PrivateRoute>
        ),
      },
      {
        path: "/live-class-list/:url",
        element: (
          <PrivateRoute>
            <LiveClassDetails />
          </PrivateRoute>
        ),
      },
      {
        path: "/top-performer",
        element: (
          <PrivateRoute>
            <TopPerformer />
          </PrivateRoute>
        ),
      },
      {
        path: "/top-performer/:startDate/:endDate",
        element: (
          <PrivateRoute>
            <TopPerformerDetails />
          </PrivateRoute>
        ),
      },
      {
        path: "/questions",
        element: (
          <PrivateRoute>
            <QuestionsList />
          </PrivateRoute>
        ),
      },
      {
        path: "/questions/:id",
        element: (
          <PrivateRoute>
            <QuestionsDetails />
          </PrivateRoute>
        ),
      },
      {
        path: "/functionality",
        element: <Functionality />,
      },
      {
        path: "/about-us",
        element: <AboutUs />,
      },
      {
        path: "/whatWeDo",
        element: <WharWeDo />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/contact",
        element: <ContactUs />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
